module.exports = __webpack_public_path__ + "static/media/Test39.81d767fe.bmp";